import axiosInstance from "../config/axiosInstance";

export const getBusinessActivitiesByLanguage = async (languageCode = "vi") => {
    try {
        const response = await axiosInstance.get(`/business-activities/${languageCode}`);
        return response?.data?.data || [];
    } catch (error) {
        console.error("Lỗi khi tải Lĩnh vực Kinh doanh:", error);
        return [];
    }
};
